import { PageContent, mediaMixin, token } from '@zillow/constellation';
import styled, { createGlobalStyle, css } from 'styled-components';

const MAX_WIDTH = '1232px';

export const InboxGlobalStyle = createGlobalStyle`

  html, body, #__next, #App, #app-root {
    overflow: hidden;    
    width: 100%;
    height: 100%;
    min-height: 100%;
  }

  #App {
    background-color: ${token('colors.backgroundWhite')};
  }

  body,
  #App,
  #__next,
  main,
  #app-root {
    display: flex;
    flex-direction: column;
  }

  main {
    height: 100%;
    overflow-y: auto;
    width: 100%;
    margin: 0 auto;
    max-width: ${MAX_WIDTH};

    @media (min-width: 992px) and (max-width: 1620px) {
      padding: 0 24px;
    }
  }

  // Global styles for ImagesViewer component
  #viewerBackdrop {
    backdrop-filter: blur(8px);

    div:first-child {
      width: 100%;
    }

    img {
      max-height: calc(100vh - 240px) !important;
    }
  }
`;

export const StyledPageContent = styled(PageContent)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  align-self: center;
  padding-left: 0;
  padding-right: 0;

  ${mediaMixin(
    'lg_lte',
    css`
      max-width: 100%;
    `,
  )}

  ${mediaMixin(
    'xl',
    css`
      max-width: ${MAX_WIDTH};
    `,
  )}
`;

export const StyledColumnWrapper = styled.div`
  height: 100%;
  display: flex;
  overflow-y: auto;
  border: 1px solid ${token('colors.gray300')};
  border-radius: 3px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;

  ${mediaMixin(
    'xl_lte',
    css`
      && {
        border: none;
        max-width: 100%;
        padding: 0;
      }
    `,
  )}

  ${mediaMixin(
    'xl',
    css`
      max-width: ${MAX_WIDTH};
      width: 100%;
    `,
  )}
`;

type ColumnProps = {
  $shouldHideOnMobile: boolean;
};

const FlexColumnStyles = css`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
`;

export const StyledPrimaryColumn = styled.div<ColumnProps>`
  ${FlexColumnStyles}

  ${mediaMixin(
    'xxl',
    css`
      && {
        max-width: 25%;
        border-right: 1px solid ${token('colors.gray300')};
      }
    `,
  )}

     ${(props) =>
    props.$shouldHideOnMobile &&
    mediaMixin(
      'xl_lte',
      css`
        && {
          display: none;
        }
      `,
    )}

  .swipeable-list {
    flex: 1;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .swipeable-list-item {
    position: relative;
    transition: max-height 0.5s ease;
    max-height: 1000px;
    transform-origin: top;
    overflow: hidden;
    width: 100%;
    z-index: 0;
  }

  .swipeable-list-item__content {
    width: 100%;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
    height: 100%;
    display: flex;
  }

  .swipeable-list-item__content--return {
    transition: transform 0.5s ease-out;
  }

  .swipeable-list-item__content--remove {
    transition: transform 0.35s ease-in;
  }

  .swipeable-list-item__content-right {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    opacity: 0;
  }

  .swipeable-list-item__content-right--return {
    transition: opacity 0.5s ease-out;
  }

  .swipeable-list-item__content-left {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    opacity: 0;
    justify-content: flex-end;
  }

  .swipeable-list-item__content-left--return {
    transition: opacity 0.5s ease-out;
  }
`;

export const StyledTertiaryColumn = styled.aside<ColumnProps>`
  ${FlexColumnStyles}

  ${mediaMixin(
    'xxl',
    css`
      && {
        max-width: 25%;
        min-width: 285px;
      }
    `,
  )}

    ${(props) =>
    props.$shouldHideOnMobile &&
    mediaMixin(
      'xl_lte',
      css`
        && {
          display: none;
        }
      `,
    )}
`;
